export default __webpack_public_path__ + "static/media/8.ce936852.mp3";